import { inject, InjectionToken } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { MeetingIntegrationsConfig } from '@vendasta/integrations';
import { AuthService } from '../auth.service';
import { AccountGroupService } from '../account-group';
import { MeetingSourceOrigin } from '@vendasta/meetings';

export enum SERVICE_KEYS {
  integrationsPage = 'integrations-page',
  eventsAndMeetingsPage = 'event-and-meetings',

  eventsAndMeetingsPageCalendarConnected = 'events-and-meetings-calendar-connected',
  eventsAndMeetingsPageConferencingConnected = 'events-and-meetings-conferencing-connected',
}
export const integrationsUrl = `/connection-redirect/integrations`;
export const eventsAndMeetingsSettingsUrls = `/connection-redirect/events-and-meetings`;

export const BUSINESS_CENTER_MEETING_INTEGRATIONS_CONFIG_TOKEN = new InjectionToken<MeetingIntegrationsConfig>(
  '[Business Center]: Config for meeting integrations',
  {
    providedIn: 'root',
    factory: function (): MeetingIntegrationsConfig {
      const authService = inject(AuthService);
      const accountGroupService = inject(AccountGroupService);
      const agid = accountGroupService.currentAccountGroupId();

      const HOSTNAME =
        window.location.hostname === 'localhost' ? `localhost:${location.port || 4200}` : window.location.hostname;

      const FULL_URL = `${window.location.protocol}//${HOSTNAME}${integrationsUrl}`;
      const EVENTS_MEETINGS_URL = `${window.location.protocol}//${HOSTNAME}/account/location/${agid}/events-and-meetings/meeting-type?defaults=true`;

      return {
        userId$: toObservable(authService.effectiveUserId),
        namespace$: accountGroupService.currentAccountGroupId$,
        origin: MeetingSourceOrigin.BusinessApp,
        redirectInfo$: {
          [SERVICE_KEYS.integrationsPage]: {
            connectionSuccessfulReturnURL: FULL_URL,
            disconnectSuccessReturnURL: FULL_URL,
          },
          [SERVICE_KEYS.eventsAndMeetingsPage]: {
            connectionSuccessfulReturnURL: EVENTS_MEETINGS_URL,
            disconnectSuccessReturnURL: EVENTS_MEETINGS_URL,
          },
          [SERVICE_KEYS.eventsAndMeetingsPageCalendarConnected]: {
            connectionSuccessfulReturnURL: `${EVENTS_MEETINGS_URL}&calendarConnected=true`,
            disconnectSuccessReturnURL: `${EVENTS_MEETINGS_URL}&calendarConnected=false`,
          },
          [SERVICE_KEYS.eventsAndMeetingsPageConferencingConnected]: {
            connectionSuccessfulReturnURL: `${EVENTS_MEETINGS_URL}&conferencingConnected=true`,
            disconnectSuccessReturnURL: `${EVENTS_MEETINGS_URL}&conferencingConnected=false`,
          },
        },
      };
    },
  },
);
